<div class="bg-white">
  <table class="dc-table dc-table-list">
    <tbody>
      @for (activity of activities; track activity; let i = $index) {
      <tr>
        <td class="w-70">{{ "ACTIVITY.TITLE" | translate }} {{ i + 1 }}</td>
        <td>
          @if(activity?.descriptionOtherEn){
          <span class="flex w-full">
            {{
              this.lang == "ar"
                ? activity.descriptionOtherAr
                : activity.descriptionOtherEn
            }}</span
          >
          }@else{
          <span class="flex w-full">
            {{ this.lang == "ar" ? activity.description : activity.name }}
          </span>
          }
          {{ activity.code }}
        </td>
      </tr>
      }
      @if (!activities || activities.length < 1) {
      <tr>
        <td class="text-center! py-4 text-dc-gray-light italic" colspan="2">
          {{ "NO_RECORD_FOUND" | translate }}
        </td>
      </tr>
      }
    </tbody>
  </table>

  <!-- <app-button
    [label]="'BUTTONS.UPDATE_ACTIVITIES' | translate"
    [classesName]="'card-edge-cut-white'"
    (onBtnClick)="updateMembership()"
  ></app-button> -->
</div>
